/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { TableSearchInput } from "~/components/SearchInput";
import { ResourceQuery } from "~/views/resources/types";
import { ResourceTableState } from "../const";

type Props = {
  setResourcesSearchPage: (resourcesPage: ResourceTableState) => void;
};

export function ResourceSearch({}: Props) {
  return (
    <TableSearchInput<ResourceQuery>
      onSubmit={() => {}}
      disabled
      placeholder={"Search"}
    />
  );
}
